// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module--block--1jmYY","blockTitle":"styles-module--blockTitle--1W2sO","blockCopy":"styles-module--blockCopy--3HMDY","closing":"styles-module--closing--Nr7VO"};